import React, { FC } from 'react';
import { t } from 'i18next';
import { TextField } from '@ui-modules/informed';

interface IPhoneNumberField {
  defaultValue?: string;
  disabled?: boolean;
  label?: string;
}

const PhoneNumberField: FC<IPhoneNumberField> = ({
  defaultValue,
  disabled,
  label = t('common.phoneNumber'),
}) => (
  <div className="field field-phone">
    <TextField disabled={disabled} initialValue={defaultValue} label={label} name="phoneNumber" />
  </div>
);

export default PhoneNumberField;
